import { type ReactNode } from 'react';

interface AuthRouteWrapperProps {
  children: ReactNode;
}

/**
 * A minimal wrapper for router content.
 * Authentication checks happen inside __root.tsx component.
 */
export const AuthRouteWrapper = ({ children }: AuthRouteWrapperProps) => {
  return children;
};

export default AuthRouteWrapper;
